import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { USER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IIntRole } from '~/Models/DTO/IntRole.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';

interface RoleUpdateRequest {
  providerId: string;
  userId: string;
  name: string;
  endDateTime?: Date | string;
  isDeactivated?: true;
  id?: string;
  description?: string;
}

export const useRequestUpdateIntRoles = () =>
  useMutation<IIntRole, IErrorResponse, RoleUpdateRequest>(
    REQUEST_ACTIONS.INTEGRATION_ROLE,
    async (roleUpdate) => {
      const response = await requestReactQuery<IIntRole>({
        url: USER_SERVICE_URLS.UPDATE_INT_ROLES,
        config: { method: 'PUT' },
        data: roleUpdate,
      });

      return response;
    },
  );
